<template>
  <div class="po-r w100 bg-w card-shadow">
    <el-row class="w100 bor-b card-title">
      <el-col class="pl20" :span="18">
        <p class="font-16 blue">{{ title }}</p>
      </el-col>
      <el-col class="pr10 tx-r" :span="6">
        <router-link class="font-14 grey" :to="moreUrl">
          {{ moreName }}
          <i class="el-icon-arrow-right"></i>
        </router-link>
      </el-col>
    </el-row>
    <div class="po-r w100 pb20 card-main" v-loading="loading" element-loading-text="正在加载，请稍后" element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-row :gutter="10" style="padding: 0 20px;" v-if="data.length > 0">
        <div v-for="(v, k) in data" :key="k" @click="routerServe(v)" :title="v.serveName">
          <el-col :span="4" class="mt10 pt10 tx-c card-app">
            <img :src="!v.serveImage ? baseUrl + 'images/icon-app.png' : v.serveImage">
            <p class="mt10 font-14 pl10 pr10 ellipsis-2">{{ v.serveName }}</p>
          </el-col>
        </div>
      </el-row>
      <div class="w100 pt20 pb20 tx-c" v-if="error == 404">
        <el-button plain @click="error = 0, fetchData()">加载失败，点击重新加载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CardAppTop",
  props: {
    title: String,
    moreName: {
      default: "更多"
    },
    moreUrl: String,
    getUrl: String
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      error: 0,
      errorMsg: "",
      data: []
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    routerServe(v) {
      if(v.serveType == 2 && v.interfaceUrl) {
        // 类似正版化这些站外服务，直接打开新窗口
        const url = decodeURIComponent(v.interfaceUrl)
        window.open(url)
        return;
      }
      const route = { name: v.serveType == 1 ? 'server_info' : 'server_search', query: { id: v.id,  interfaceUrl: v.interfaceUrl ? v.interfaceUrl.replace(/\/| /g,'') : null }}
      this.$router.push(route)
    },
    fetchData() {
      this.loading = true;

      this.$http
        .post(
          this.getUrl,
          this.$qs.stringify({
            size: 18
          })
        )
        .then(({ data }) => {
          if (data.resStatus == 0) {
            if (data.resStatus == 0) {
              this.data = data.resData;
            }
          } else {
            this.error = data.resStatus;
            this.errorMsg = data.resMsg;
          }

          this.loading = false;
        })
        .catch(() => {
          this.error = 404;
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.card-app-title::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 3px;
  height: 1em;
  background: #475eb7;
}

.card-app {
  height: 124px;
}

.card-app:hover {
  color: #475eb7;
}

.card-app img {
  width: 60px;
  height: 60px;
}
</style>
